module.exports = __webpack_public_path__ + "static/media/whiteDownloadSvg.4187e233.svg";